import React, { useState, useEffect, useContext, useRef, useMemo, useCallback } from 'react';
import axiosInstance from './axiosInstance';
import './StudentFee.css';
import AdminNav from '../Navbars/AdminNav';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../UserContext';
import logo from '../CourseImages/Logo.png';
import footer from "../CourseImages/footer.png";
import jsPDF from 'jspdf';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
import axios from 'axios';
import html2canvas from 'html2canvas';
import { usePDF, Resolution } from 'react-to-pdf';
import Footer from "../Footer";
import { toast } from 'react-toastify';
import { debounce } from 'lodash';
import { memo } from 'react';
import { useInView } from 'react-intersection-observer';

const InvoicePage = () => {
  const navigate = useNavigate();
  const { isAdmin, isTeacher, isStudent, isGuest, setUserRole, setUserInfo, userInfo } = useContext(UserContext);
  const [invoiceNumber, setInvoiceNumber] = useState(0);
  const [invoiceList, setInvoiceList] = useState([]);
  const currentDate = new Date();
  let daysToExpire = 0;
  const options = { day: '2-digit', month: 'short', year: 'numeric' };

  const expiryDate = new Date(currentDate);
  expiryDate.setDate(currentDate.getDate() + parseInt(daysToExpire || 5));
  let formattedExpiryDate = expiryDate.toLocaleDateString('en-GB', options).replace(',', '');;

  const [invoiceData, setInvoiceData] = useState({
    student: '',
    course: '',
    currency: 'PKR',
    monthlyQuantity: 1,
    monthlyFee: 0,
    monthlyDiscount: 0,
    monthlyDiscountPercent: 0,
    membershipQuantity: 1,
    membershipFee: 0,
    membershipDiscount: 0,
    membershipDiscountPercent: 0,
    abacusQuantity: 1,
    abacusFee: 0,
    abacusDiscount: 0,
    abacusDiscountPercent: 0,
    outstandingPayment: false,
    deliveryCharges: false,
    bankDetails: `Bank Name: ${process.env.REACT_APP_Bank_Name} \nAccount holder: ${process.env.REACT_APP_Holder} \nLTDIBAN: ${process.env.REACT_APP_LTDIBAN}`,
    note: '',
    studentName: '',
    studentEmail: '',
    parentname: "",
    phonenumber: "",
    address: "",
    courseName: '',
    subtotal: 0,
    total: 0,
    totalPayable: 0,
    quantity: 0,
    note: "",
    transactionCharges: 0,
  });

  const [formData, setFormData] = useState({
    student: '',
    course: '',
    currency: 'PKR',
    monthlyQuantity: 1,
    monthlyFee: 0,
    monthlyDiscount: 0,
    monthlyDiscountPercent: 0,
    membershipQuantity: 1,
    membershipFee: 0,
    membershipDiscount: 0,
    membershipDiscountPercent: 0,
    abacusFee: 0,
    abacusQuantity: 1,
    abacusDiscount: 0,
    abacusDiscountPercent: 0,
    outstandingPayment: false,
    deliveryCharges: false,
    bankDetails: `Bank Name: ${process.env.REACT_APP_Bank_Name} \nAccount holder: ${process.env.REACT_APP_Holder} \nLTDIBAN: ${process.env.REACT_APP_LTDIBAN}`,
    note: '',
    transactionCharges: 0,
  });

  const [students, setStudents] = useState([]);
  const [courses, setCourses] = useState([]);
  const [reloadData, setReloadData] = useState(false);
  const [discountList, setDiscountList] = useState([]);
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
  const [selectedStudentForTable, setSelectedStudentForTable] = useState('');
  const [filteredInvoices, setFilteredInvoices] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [showInvoices, setShowInvoices] = useState(false); // New state for toggling invoices
  const [searchTerm, setSearchTerm] = useState(''); // Search state for invoices
  const [studentSearchTerm, setStudentSearchTerm] = useState(''); // Search state for student selection
  const [showStudentSuggestions, setShowStudentSuggestions] = useState(false);
  const { ref: loadingRef, inView } = useInView();

  // Create ref for PDF configuration
  const pdfRef = useRef(null);

  // Move usePDF hook after state initialization
  // const { toPDF, targetRef } = usePDF({
  //   filename: () => {
  //     return `invoice No ${invoiceNumber} - ${invoiceData?.studentName} -${invoiceData?.courseName} - ${new Date().toLocaleDateString('en-GB', options).replace(',', '')}.pdf`;
  //   },
  //   resolution: Resolution.NORMAL
  // });
  const { toPDF, targetRef } = usePDF({ filename: `invoice No ${invoiceNumber} - ${invoiceData?.studentName} -${invoiceData?.courseName} - ${new Date().toLocaleDateString('en-GB', options).replace(',', '')}.pdf`, resolution: Resolution.NORMAL });

  // Store toPDF function in ref for access in callbacks
  useEffect(() => {
    pdfRef.current = toPDF;
  }, [toPDF]);

  // 1. Memoize expensive calculations and callbacks
  const filteredInvoicesList = useMemo(() => {
    return selectedStudentForTable ?
      invoiceList.filter(invoice => invoice.User_id === parseInt(selectedStudentForTable)) :
      invoiceList;
  }, [selectedStudentForTable, invoiceList]);

  // 2. Debounce the handleSubmit function
  const debouncedHandleSubmit = useCallback(
    debounce(() => {
      const selectedStudent = students.find(student => student.User_id === parseInt(formData.student));
      const selectedCourse = courses.find(course => course.Course_id === parseInt(formData.course));

      // Ensure all values are numbers before performing calculations
      const monthlyFee = parseFloat(formData.monthlyFee) || 0;
      const membershipFee = parseFloat(formData.membershipFee) || 0;
      const abacusFee = parseFloat(formData.abacusFee) || 0;
      const monthlyDiscount = parseFloat(formData.monthlyDiscount) || 0;
      const membershipDiscount = parseFloat(formData.membershipDiscount) || 0;
      const abacusDiscount = parseFloat(formData.abacusDiscount) || 0;
      const outstandingPayment = parseFloat(formData.outstandingPayment) || 0;
      const deliveryCharges = parseFloat(formData.deliveryCharges) || 0;
      const monthlyQuantity = parseFloat(formData.monthlyQuantity) || 1;
      const membershipQuantity = parseFloat(formData.membershipQuantity) || 1;
      const abacusQuantity = parseFloat(formData.abacusQuantity) || 1;

      // Quantity
      const quantity = parseFloat(formData.Quantity) || 1;

      // Calculate total
      const total = (monthlyFee - monthlyDiscount) * monthlyQuantity
        + (membershipFee - membershipDiscount) * membershipQuantity
        + (abacusFee - abacusDiscount) * abacusQuantity
        + outstandingPayment
        + deliveryCharges;

      const subtotal = (monthlyFee) * monthlyQuantity
        + (membershipFee) * membershipQuantity
        + (abacusFee) * abacusQuantity
        + outstandingPayment
        + deliveryCharges;

      const totalPayable = total + (total * (formData.transactionCharges / 100));

      const data = {
        ...formData,
        studentName: selectedStudent ? selectedStudent.firstname + " " + selectedStudent.lastname : '',
        studentEmail: selectedStudent ? selectedStudent?.email : '',
        parentname: selectedStudent ? selectedStudent.parentname : "",
        phonenumber: selectedStudent ? selectedStudent.phonenumber : "",
        address: selectedStudent ? selectedStudent.address : "",
        courseName: selectedCourse ? selectedCourse.coursename : '',
        total: parseFloat(total.toFixed(2)),
        subtotal: parseFloat(subtotal.toFixed(2)),
        totalPayable: parseFloat(totalPayable.toFixed(2)),
        quantity
      };

      setInvoiceData(data);
    }, 300),
    [formData, students, courses]
  );

  // 3. Optimize useEffect dependencies
  useEffect(() => {
    debouncedHandleSubmit();
    return () => debouncedHandleSubmit.cancel();
  }, [debouncedHandleSubmit]);

  // 4. Memoize the fetchCourses function
  const fetchCourses = useCallback(async (value) => {
    try {
      const selectedStudent = students.find(student => student.User_id == value);
      if (!selectedStudent) return;

      const response = await axiosInstance.get(`/coursesByStudentId/${selectedStudent?.Student_id}`);
      const sortedCourses = response.data.slice().sort((a, b) => {
        return a.coursename.localeCompare(b.coursename);
      });
      setCourses(sortedCourses);
    } catch (error) {
      console.error('Error fetching courses:', error);
      toast.error('Failed to fetch courses');
    }
  }, [students]);

  // Initialize bankDetailsFromApi as an empty array
  const [bankDetailsFromApi, setBankDetailsFromApi] = useState([]);

  // Update the useEffect to handle the initial currency
  useEffect(() => {
    const fetchBankDetails = async () => {
      try {
        const response = await axios.get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/bankDetails`);
        setBankDetailsFromApi(response.data); // Ensure it's an array
        console.log("response.data : ", response.data)
        // Set initial bank details for PKR
        const initialDetails = response?.data
          ?.filter(detail => detail?.currency == formData?.currency)
          .map(detail => detail?.details)
          .join('\n');

        setFormData(prev => ({
          ...prev,
          bankDetails: initialDetails || ''
        }));

      } catch (error) {
        console.error('Error fetching bank details:', error);
        toast.error('Failed to fetch bank details');
        // setBankDetailsFromApi([]); // Set empty array on error
      }
    };

    fetchBankDetails();
  }, []);

  // Update handleChange to properly handle currency changes
  const handleChange = useCallback(async (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "currency") {
      // First update the currency
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));

      // Then update bank details for the selected currency
      if (bankDetailsFromApi && Array.isArray(bankDetailsFromApi)) {
        // const selectedCurrencyDetails = bankDetailsFromApi
        //   .filter(detail => detail.currency === formData.currency)
        //   .map(detail => detail.details)
        //   .join('\n');

        // setFormData(prev => ({
        //   ...prev,
        //   bankDetails: selectedCurrencyDetails || ''
        // }));
        console.log("bankDetailsFromApi : ", bankDetailsFromApi)
        console.log("formData.currency : ", value)
        const initialDetails = bankDetailsFromApi
          ?.filter(detail => detail.currency == value)
          .map(detail => detail.details)
          .join('\n');

        setFormData(prev => ({
          ...prev,
          bankDetails: initialDetails || ''
        }));
      }
    } else {
      // Handle other form field changes
      setFormData(prev => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : value
      }));

      if (name === "student") {
        const studentId = value;
        const selectedStudent = students.find(s => s.User_id == studentId);
        if (selectedStudent) {
          setStudentSearchTerm(`${selectedStudent.firstname} ${selectedStudent.lastname || ''}`);
        }
        fetchCourses(studentId);
        const filtered = studentId ?
          invoiceList.filter(invoice => invoice.User_id === parseInt(studentId)) :
          invoiceList;
        setFilteredInvoices(filtered);
      }
    }
  }, [fetchCourses, invoiceList, bankDetailsFromApi, students]);

  const handleStudentSearchChange = (e) => {
    const value = e.target.value;
    setStudentSearchTerm(value);
    setShowStudentSuggestions(true);
    // If user clears the search, clear the selected student as well
    if (!value) {
      setFormData(prev => ({ ...prev, student: '' }));
      setCourses([]);
    }
  };

  const selectStudent = (student) => {
    setFormData(prev => ({ ...prev, student: student.User_id }));
    setStudentSearchTerm(`${student.firstname} ${student.lastname || ''}`);
    setShowStudentSuggestions(false);
    fetchCourses(student.User_id);
    const filtered = invoiceList.filter(invoice => invoice.User_id === parseInt(student.User_id));
    setFilteredInvoices(filtered);
  };

  const toggleStudentSuggestions = () => {
    setShowStudentSuggestions(prev => !prev);
  };

  const filteredStudents = useMemo(() => {
    if (!studentSearchTerm) return students;
    return students.filter(student =>
      `${student.firstname} ${student.lastname || ''}`.toLowerCase().includes(studentSearchTerm.toLowerCase()) ||
      student.username?.toLowerCase().includes(studentSearchTerm.toLowerCase())
    ).slice(0, 20); // Show more for full list
  }, [students, studentSearchTerm]);

  // 6. Optimize the PDF generation
  const downloadPDF = useCallback(async (e) => {
    e.preventDefault();
    setIsGeneratingPDF(true);

    try {
      if (pdfRef.current) {
        await pdfRef.current();
        toast.success('PDF generated successfully!', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error('Error generating PDF:', error);
      toast.error('Failed to generate PDF', {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } finally {
      setIsGeneratingPDF(false);
    }
  }, []);

  // 7. Optimize the invoice list rendering
  const renderInvoiceList = useMemo(() => {
    return filteredInvoices?.map((item) => (
      <tr key={item.Fee_id}>
        <td>
          <input
            type='checkbox'
            defaultChecked={item?.paid}
            onChange={(e) => changePaidStatus(e.target.value, item.Fee_id)}
          />
        </td>
        <td><a className='invoiceLink' href={process.env.REACT_APP_Invoice_Path + item?.InvoiceFile} target="_blank">Invoice No  {item?.Fee_id}</a></td>
        <td>{item?.username} {item?.lastname}</td>
        <td className={item?.paid ? "" : "unpaid"}>{item?.coursename}</td>
        <td className={item?.paid ? "" : "unpaid"}>{item?.generationdate}</td>
        <td className={item?.paid ? "" : "unpaid"}>{item?.amountdue}</td>
        <td className={item?.paid ? "" : "unpaid"}>{item?.duedate}</td>
        <td><input type='number' placeholder={item?.amountdue}
          onKeyDown={(e) => {
            if (e.key === "Enter")
              changeAmountPaid(e.target.value, item.Fee_id)
          }}
        /></td>
        <td><input
          value={(item?.paiddate === '2030-01-01' || item?.paiddate === '2024-08-18') ? "" : item?.paiddate}
          type='date'
          onChange={(e) => changePaidDate(e.target.value, item.Fee_id)}
        /></td>
        <td></td>
      </tr>
    ));
  }, [filteredInvoices, changePaidStatus, changePaidDate, changeAmountPaid]);

  // 8. Add cleanup on component unmount
  useEffect(() => {
    return () => {
      // Cleanup any subscriptions or pending operations
      setInvoiceList([]);
      setFilteredInvoices([]);
      setCourses([]);
      setStudents([]);
    };
  }, []);

  useEffect(() => {
    if (typeof process !== 'undefined' && process.env) {
      daysToExpire = process.env.REACT_APP_Fee_Due_Days || 12;
      formattedExpiryDate = expiryDate.toLocaleDateString('en-GB', options).replace(',', '');;
    }

    const fetchStudents = async () => {
      try {
        const response = await axiosInstance.get('/student');
        setStudents(response.data);
      } catch (error) {
        console.error('Error fetching students:', error);
      }
    };
    axios.get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getDiscounts`).then((res) => {
      console.log("setDiscountList : ", res?.data?.discounts)
      setDiscountList(res?.data?.discounts)
    })

    // 
    fetchCourses();
    fetchStudents();
    axios.get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/generateInvoiceNumber`).then((res) => {
      console.log("setInvoiceNumber : ", res?.data?.invoiceNumber)

      setInvoiceNumber(res?.data?.invoiceNumber)
    })
  }, []);

  const handleTableStudentChange = (e) => {
    const value = e.target.value;
    setSelectedStudentForTable(value);
    setPage(1); // Reset page number when filter changes
    setFilteredInvoices([]); // Clear existing invoices
    fetchInvoiceList(1, value, searchTerm); // Fetch first page with filter
  };
  const handleChangeDiscount = async (e, discount, fee) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
      [discount]: (e.target.value / 100) * fee,
    })
  }

  async function onLogout() {
    await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/logout`, {
      credentials: 'include',
      method: 'POST',
    });
    // setUserInfo(null);
    console.log("navigating");
    navigate('/');
    // console.log("navigated");
    // setUserRole('guest');
  }
  const username = userInfo?.username;
  const _avatar_ = userInfo?.avatar;
  const fetchInvoiceList = useCallback(async (pageNum = 1, studentId = null, search = '') => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/allStudentsInvoiceDetails`, {
        params: {
          page: pageNum,
          limit: 10,
          studentId: studentId, // Add studentId as a parameter
          search: search // Add search parameter
        }
      });

      const { invoices, pagination } = response.data;

      setFilteredInvoices(prev =>
        pageNum === 1 ? invoices : [...prev, ...invoices]
      );

      setHasMore(pagination.currentPage < pagination.totalPages);
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching Invoices:', error);
      toast.error('Failed to fetch invoices');
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (showInvoices) {
      // If we have a search term or filter, use it
      fetchInvoiceList(1, selectedStudentForTable, searchTerm);
    }
  }, [reloadData, showInvoices]) // Note: excluding searchTerm here to avoid double fetch if I use separate effect, but...

  // Debounced Search Effect
  useEffect(() => {
    // If search is empty and list is closed, do nothing (initial state)
    if (!showInvoices && !searchTerm) return;

    const timer = setTimeout(() => {
      if (!showInvoices && searchTerm) {
        // User started typing while closed. Open list.
        setShowInvoices(true);
      } else {
        // List is already open, or just refreshing. Fetch directly.
        setPage(1);
        setFilteredInvoices([]);
        fetchInvoiceList(1, selectedStudentForTable, searchTerm);
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [searchTerm]); // Triggers on search change

  // Add effect for infinite scroll
  useEffect(() => {
    if (inView && hasMore && !isLoading) {
      setPage(prev => prev + 1);
      fetchInvoiceList(page + 1, selectedStudentForTable, searchTerm);
    }
  }, [inView, hasMore, isLoading, fetchInvoiceList, page, selectedStudentForTable, searchTerm]);

  // const sendEmail = useCallback(async (e) => {
  //   e.preventDefault();
  //   try {
  //     if (!pdfRef.current) {
  //       throw new Error('PDF generation not initialized');
  //     }

  //     const pdf = await pdfRef.current();
  //     const pdfBlob = pdf.output('blob');

  //     const formDataInvoice = new FormData();
  //     formDataInvoice.append('pdfFile', pdfBlob, `invoice-${invoiceData?.studentName}.pdf`);
  //     formDataInvoice.append('invoiceData', JSON.stringify(invoiceData));

  //     await axios.post(
  //       `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/generateInvoice`,
  //       formDataInvoice,
  //       {
  //       headers: {
  //         'Content-Type': 'multipart/form-data',
  //       }
  //       }
  //     );

  //     setInvoiceNumber(prev => prev + 1);
  //     setTimeout(fetchInvoiceList, 1000);

  //     toast.success('Email sent successfully!');
  //   } catch (error) {
  //     console.error('Error generating invoice:', error);
  //     toast.error('Failed to send email');
  //   }
  // }, [invoiceData]);
  const sendEmail = async (e) => {

    try {
      e.preventDefault()
      const pdf = await toPDF();
      // const pdfBlob = await new Blob([pdfInstance.output("blob")], {
      //   type: "application/pdf",
      // });
      const pdfBlob = pdf.output('blob');


      // Create FormData and append the PDF
      const formDataInvoice = new FormData();
      // formDataInvoice.append('pdfFile', pdfBlob);
      formDataInvoice.append('pdfFile', pdfBlob, `invoice-${invoiceData?.studentName}.pdf`);


      // Add any other data you need to send
      const invoiceDataWithoutBank = { ...invoiceData };
      delete invoiceDataWithoutBank.bankDetails;
      formDataInvoice.append('invoiceData', JSON.stringify(invoiceDataWithoutBank));

      // formDataInvoice.append('invoiceData', invoiceData);

      const response = await axios.post(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/generateInvoice`, formDataInvoice, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      }).then(() => {
        setInvoiceNumber(invoiceNumber + 1)
        setTimeout(() => {
          fetchInvoiceList()
        }, 1000)
      })
      console.log(response.data);
    } catch (error) {
      console.error('Error generating invoice:', error);
    }

  }
  async function changePaidStatus(value, fee_id) {
    // alert(value+"--"+fee_id)
    const response = await axios.get(
      `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/markPaymentDone/${fee_id}/1`
    ).then(() => {
      setReloadData(!reloadData)
    })

  }
  async function changeAmountPaid(value, fee_id) {
    // alert(value+"--"+fee_id)
    const response = await axios.get(
      `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/amountPaid/${fee_id}/${value}`
    ).then(() => {
      setReloadData(!reloadData)
    })

  }
  async function changePaidDate(value, fee_id) {
    const response = await axios.get(
      `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/markPaidDate/${fee_id}/${value}`
    ).then(() => {
      setReloadData(!reloadData)
    })
  }
  function formatDate(dateString = "") {
    if (dateString == "") {
      return ""
    }
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'short' });
    return `${day} ${month}`;
  }

  return (
    <>
      <AdminNav username={username} avatar={_avatar_} onLogout={onLogout} />
      <div className="invoice-page">
        <form
          // onSubmit={handleSubmit}
          //  onChange={handleSubmit} 
          className="invoice-form">
          <div className="form-group student-selection-unified">
            <label><strong>Select Student</strong></label>
            <div className="unified-search-select">
              <div className="input-with-arrow">
                <input
                  type="text"
                  placeholder="Search and Select Student..."
                  value={studentSearchTerm}
                  onChange={handleStudentSearchChange}
                  onFocus={() => setShowStudentSuggestions(true)}
                  // onBlur={() => setTimeout(() => setShowStudentSuggestions(false), 200)}
                  autoComplete="off"
                />
                <div className={`dropdown-arrow ${showStudentSuggestions ? 'open' : ''}`} onClick={toggleStudentSuggestions}>
                  <i className="fas fa-chevron-down"></i>
                </div>
              </div>
              {showStudentSuggestions && (
                <div className="suggestions-container-fixed">
                  <div className="suggestions-header">
                    <span>Search Results</span>
                    <button type="button" onClick={() => setShowStudentSuggestions(false)}>X</button>
                  </div>
                  <ul className="student-suggestions">
                    {filteredStudents.length > 0 ? (
                      filteredStudents.map(student => (
                        <li key={student.User_id} onClick={() => selectStudent(student)}>
                          {student.firstname} {student.lastname} ({student.username})
                        </li>
                      ))
                    ) : (
                      <li className="no-results">No students found</li>
                    )}
                  </ul>
                </div>
              )}
            </div>
            {/* Keeping hidden select for any background logic dependencies */}
            <select name="student" value={formData.student} onChange={handleChange} style={{ display: 'none' }}>
              <option value="">Select Student</option>
              {students.map(student => (
                <option key={student.User_id} value={parseInt(student.User_id)}>{student.firstname} {student?.lastname}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            {/* <label>Choose a Course</label> */}
            <select name="course" value={formData.course} onChange={handleChange}>
              <option value="">Select Course</option>
              {courses.map(course => (
                <option key={course.Course_id} value={course.Course_id}>{course.coursename}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            {/* <label>Currency</label> */}
            <select name="currency" value={formData.currency} onChange={handleChange}>
              <option value="PKR">PKR</option>
              <option value="USD">USD</option>
              <option value="AUD">AUD </option>
              <option value="Pounds"> Pounds </option>
              <option value="Euros"> Euros </option>
              <option value="UAE Dirhams"> UAE Dirhams </option>
              <option value="Riyal"> Riyal </option>
              <option value="Canadian Dollars"> Canadian Dollars </option>
            </select>
          </div>

          <div className="fee-section">

            <div className="form-group monthly-fee">
              <label> <strong>Monthly Fee</strong></label>
              <div>
                <input
                  type="checkbox"
                  name="monthlyFee"
                  checked={formData.monthlyFee > 0}
                  onChange={handleChange}
                  style={{ width: "10%" }}

                />
                <input
                  type="number"
                  name="monthlyFee"
                  value={formData.monthlyFee}
                  onChange={handleChange}
                  placeholder="Fee"
                  style={{ width: "42%" }}
                />

                <input
                  type="number"
                  name="monthlyQuantity"
                  value={formData.monthlyQuantity}
                  onChange={handleChange}
                  placeholder="Quantity"
                  style={{ width: "38%", marginLeft: "5px" }}
                />
              </div>
              <div style={{ marginTop: "10px" }}>
                <input
                  type="checkbox"
                  name="monthlyFee"
                  checked={formData.monthlyDiscount > 0}
                  // onChange={handleChange}
                  style={{ width: "10%" }}

                />
                <select name='monthlyDiscountPercent'
                  // onChange={handleChange}
                  onChange={(e) => handleChangeDiscount(e, "monthlyDiscount", invoiceData?.monthlyFee)}

                  style={{ width: "38%", marginRight: "5px" }}>
                  <option value={0}>Discount</option>
                  {
                    discountList && discountList?.map((item) => (
                      <option value={item?.discountpercentage}>
                        {item?.discountname}
                      </option>
                    ))
                  }
                  <option value={35}>35% Discount</option>
                  <option value={45}>45% Discount</option>
                </select>
                <input
                  type="number"
                  name="monthlyDiscount"
                  value={formData.monthlyDiscount}
                  // value={(invoiceData?.monthlyDiscountPercent/100)*invoiceData?.monthlyFee}
                  onChange={handleChange}
                  placeholder="Discount"
                  style={{ width: "38%" }}
                  disabled
                />
              </div>
              <div className="date-inputs" style={{ marginTop: "10px" }}>
                <div className="form-group">
                  {/* <label label>L1 Date</label> */}
                  <input placeholder='L1 Date'
                    onFocus={(e) => (e.target.type = "date")}
                    onBlur={(e) => (e.target.type = "text")}
                    type="text" name="l1Date" value={formData.l1Date} onChange={handleChange} />
                </div>
                <div className="form-group">
                  {/* <label>L2 Date</label> */}
                  <input placeholder='L2 Date' onFocus={(e) => (e.target.type = "date")}
                    onBlur={(e) => (e.target.type = "text")}
                    type="text" name="l2Date" value={formData.l2Date} onChange={handleChange} />
                </div>
                <div className="form-group">
                  {/* <label>L3 Date</label> */}
                  <input placeholder='L3 Date' onFocus={(e) => (e.target.type = "date")}
                    onBlur={(e) => (e.target.type = "text")}
                    type="text" name="l3Date" value={formData.l3Date} onChange={handleChange} />
                </div>
                <div className="form-group">
                  {/* <label>L4 Date</label> */}
                  <input placeholder='L4 Date' onFocus={(e) => (e.target.type = "date")}
                    onBlur={(e) => (e.target.type = "text")}
                    type="text" name="l4Date" value={formData.l4Date} onChange={handleChange} />
                </div>
              </div>

            </div>
            <div className="form-group membership-fee">
              <label><strong>Membership Fee</strong></label>
              <div className="form-group ">
                <div>
                  <input
                    type="checkbox"
                    name="membershipFee"
                    checked={formData.membershipFee > 0}
                    onChange={handleChange}
                    style={{ width: "10%" }}
                  />

                  <input
                    type="number"
                    name="membershipFee"
                    value={formData.membershipFee}
                    onChange={handleChange}
                    placeholder="Fee"
                    style={{ width: "40%" }}
                  />
                  <input
                    type="number"
                    name="membershipQuantity"
                    value={formData.membershipQuantity}
                    onChange={handleChange}
                    placeholder="Quantity"
                    style={{ width: "38%", marginLeft: "5px" }}
                  />
                  <select name='membershipDiscountPercent'
                    // onChange={handleChange}
                    onChange={(e) => handleChangeDiscount(e, "membershipDiscount", invoiceData?.membershipFee)}
                    style={{ width: "38%", marginLeft: "10%" }}>
                    <option value={0}>Discount</option>
                    {
                      discountList && discountList?.map((item) => (
                        <option value={item?.discountpercentage}>
                          {item?.discountname}
                        </option>
                      ))
                    }
                    <option value={35}>35% Discount</option>
                    <option value={45}>45% Discount</option>
                  </select>
                  <input
                    type="number"
                    name="membershipDiscount"
                    value={formData.membershipDiscount}
                    onChange={handleChange}
                    placeholder="Discount"
                    style={{ width: "40%", marginLeft: "10px", marginTop: "10px" }}
                    disabled
                  />
                </div>

              </div>
            </div>

            <div className="form-group abacus-fee">
              <label><strong>Soroban Abacus Fee</strong></label>
              <div>
                <input
                  type="checkbox"
                  name="abacusFee"
                  checked={formData.abacusFee > 0}
                  onChange={handleChange}
                  style={{ width: "10%" }}
                />

                <input
                  type="number"
                  name="abacusFee"
                  value={formData.abacusFee}
                  onChange={handleChange}
                  placeholder="Fee"
                  style={{ width: "40%" }}
                />
                <input
                  type="number"
                  name="abacusQuantity"
                  value={formData.abacusQuantity}
                  onChange={handleChange}
                  placeholder="Quantity"
                  style={{ width: "40%", marginLeft: "5px" }}
                />

                <select
                  name='abacusDiscountPercent'
                  onChange={(e) => handleChangeDiscount(e, "abacusDiscount", invoiceData?.abacusFee)}
                  style={{ width: "40%", marginLeft: "10%" }}
                >
                  <option value={0}>Discount</option>
                  {
                    discountList && discountList?.map((item) => (
                      <option
                        value={item?.discountpercentage}>
                        {item?.discountname}
                      </option>
                    ))
                  }
                  <option value={35}>35% Discount</option>
                  <option value={45}>45% Discount</option>
                </select>
                <input
                  type="number"
                  name="abacusDiscount"
                  value={formData.abacusDiscount}
                  onChange={handleChange}
                  placeholder="Discount"
                  style={{ width: "40%", marginLeft: "5px", marginTop: "10px" }}
                  disabled
                />

              </div>
            </div>


            <div className="form-group outstanding-fee">
              <label><strong>Outstanding Payment</strong></label>
              <div>
                <input
                  type="checkbox"
                  name="outstandingPayment"
                  checked={formData.outstandingPayment}
                  onChange={handleChange}
                  style={{ width: "10%" }}
                />

                <input
                  type="number"
                  name="outstandingPayment"
                  value={formData.outstandingPayment}
                  onChange={handleChange}
                  placeholder="Outstanding Payment"
                  style={{ width: "90%" }}
                />
              </div>

            </div>
            <div className="form-group delivery-fee">
              <label><strong>Delivery Charges</strong></label>
              <div>
                <input
                  type="checkbox"
                  name="deliveryCharges"
                  checked={formData.deliveryCharges}
                  onChange={handleChange}
                  style={{ width: "10%" }}
                />

                <input
                  type="number"
                  name="deliveryCharges"
                  value={formData.deliveryCharges}
                  onChange={handleChange}
                  placeholder="Delivery Charges"
                  style={{ width: "90%" }}
                />

              </div>
            </div>
            <div className="form-group outstanding-fee">
              <label><strong>Transaction Charges %</strong></label>
              <div>
                <input
                  type="checkbox"
                  name="transactionCharges"
                  checked={formData.transactionCharges}
                  onChange={handleChange}
                  style={{ width: "10%" }}
                />

                <input
                  type="number"
                  name="transactionCharges"
                  value={formData.transactionCharges}
                  onChange={handleChange}
                  placeholder="Transaction Charges %"
                  style={{ width: "90%" }}
                />

              </div>
            </div>

          </div>
          <div className="form-group">
            <label><strong>Note</strong></label>
            <textarea
              name="note"
              value={formData.note}
              onChange={handleChange}
              placeholder="Enter note here"
              rows={3}
              style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
            ></textarea>
          </div>
          <div className="form-group bank-details">
            <label><strong>Bank Details</strong></label>
            <textarea
              name="bankDetails"
              value={formData.bankDetails}
              onChange={handleChange}
              placeholder="Enter bank details here"
              rows={6}
              style={{ height: "150px" }}
            ></textarea>
          </div>


          {/* <button onClick={() => toPDF()}>Download PDF</button> */}

          <button
            type="button"
            className="action-btn"
            onClick={(e) => downloadPDF(e)}
            disabled={isGeneratingPDF}
            style={{
              cursor: isGeneratingPDF ? 'not-allowed' : 'pointer',
              opacity: isGeneratingPDF ? 0.7 : 1
            }}
          >
            {isGeneratingPDF ? (
              <span>
                Generating PDF...
                <i className="fas fa-spinner fa-spin" style={{ marginLeft: '8px' }}></i>
              </span>
            ) : (
              'Generate Fee & PDF'
            )}
          </button>
          <button type="button" className="action-btn" onClick={(e) => sendEmail(e)}>Send Email & Insert Data in DB</button>
        </form>

        {invoiceData && (
          <div className="invoice-display" id='invoice-display'>
            {/* Wrapper for PDF generation to allow scrolling in parent but full capture here */}
            <div className="invoice-printable-content" ref={targetRef} style={{ position: "relative", minHeight: "100%", paddingBottom: "280px" }}>
              <div style={{ zIndex: "1", position: "relative" }}>
                <div className="invoice-header">
                  <img src={logo} height={100}></img>
                  <p style={{ display: "flex", justifyContent: "flex-start", textAlign: "right", margin: "0" }}>Invoice No: {invoiceNumber}</p>
                </div>

                <h2 style={{ display: "flex", justifyContent: "flex-start", textAlign: "left" }}>INVOICE</h2>
                <div style={{ display: "flex" }}>
                  <div style={{ width: "50%" }} >
                    <p style={{ lineHeight: "2", margin: "0", display: "flex", justifyContent: "flex-start", textAlign: "left" }}><strong>Child Name:</strong> {invoiceData?.studentName}</p>
                    <p style={{ lineHeight: "2", margin: "0", display: "flex", justifyContent: "flex-start", textAlign: "left" }}><strong>Course Name:</strong> {invoiceData?.courseName}</p>
                    <p style={{ lineHeight: "2", margin: "0", display: "flex", justifyContent: "flex-start", textAlign: "left" }}><strong>Invoice Date:</strong> {new Date().toLocaleDateString('en-GB', options).replace(',', '')}</p>
                  </div>
                  <div style={{ display: "flex", alignItems: "end", height: "full" }}>
                    <p style={{ lineHeight: "2", margin: "0" }}><strong>Due Date:</strong> {formattedExpiryDate.slice(0, 15)}</p>

                  </div>
                </div>
                <br />
                <div style={{ display: "flex" }}>
                  <div style={{ width: "50%" }} >
                    <p style={{ lineHeight: "2", margin: "0", display: "flex", justifyContent: "flex-start", textAlign: "left" }}><strong>Billed to:</strong> </p>
                    <div className='billed'>
                      <p>{invoiceData?.parentname}</p>
                      <p>{invoiceData?.phonenumber}</p>
                      <p>{invoiceData?.studentEmail}</p>
                      <p>{invoiceData?.address}</p>
                    </div>
                  </div>
                  <div style={{ width: "50%" }} >
                    <p style={{ lineHeight: "2", margin: "0", textAlign: "left" }}><strong>Billed From:</strong> </p>
                    <div className='billed'>
                      <p>Polymath-Kids.com</p>
                      <p>+92 3266699907</p>
                      <p>info@polymath-kids.com</p>
                    </div>
                  </div>
                </div>


                <table>
                  <thead>
                    <tr>
                      <th>Item</th>
                      <th>Quantity</th>
                      <th>Price</th>
                      {/* <th>Discount</th> */}
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* Monthly Fee */}
                    {invoiceData?.monthlyFee > 0 && (
                      <tr>
                        <td>{`Lesson Fee (4 Lesson )`}<br />

                          {formatDate(formData?.l1Date)}{formData.l1Date ? "," : ""} {formatDate(formData?.l2Date)}{formData.l2Date ? "," : ""} {formatDate(formData?.l3Date)}{formData.l4Date ? "," : ""} {formatDate(formData?.l4Date)}
                        </td>
                        <td>{invoiceData?.monthlyQuantity}</td>
                        <td>{invoiceData?.currency} {invoiceData?.monthlyFee}</td>
                        <td>{invoiceData?.currency} {(invoiceData?.monthlyFee) * invoiceData?.monthlyQuantity}</td>
                      </tr>
                    )}

                    {/* Membership Fee */}
                    {invoiceData?.membershipFee > 0 && (
                      <tr>
                        <td>{`Membership Fee (4 Lesson )`}</td>
                        <td>{invoiceData?.membershipQuantity}</td>
                        <td>{invoiceData?.currency} {invoiceData?.membershipFee}</td>
                        <td>{invoiceData?.currency} {(invoiceData?.membershipFee - invoiceData?.membershipDiscount) * invoiceData?.membershipQuantity}</td>
                      </tr>
                    )}

                    {/* Abacus Fee */}
                    {invoiceData?.abacusFee > 0 && (
                      <tr>
                        <td>Abacus Fee</td>
                        <td>{invoiceData?.abacusQuantity}</td>
                        <td>{invoiceData?.currency} {invoiceData?.abacusFee}</td>
                        <td>{invoiceData?.currency} {(invoiceData?.abacusFee - invoiceData?.abacusDiscount) * invoiceData?.abacusQuantity}</td>
                      </tr>
                    )}

                    {/* Outstanding Payment */}
                    {invoiceData?.outstandingPayment > 0 && (
                      <tr>
                        <td>Outstanding Payment</td>
                        <td></td>
                        <td></td>
                        {/* <td></td> */}
                        <td>{invoiceData?.currency} {invoiceData?.outstandingPayment}</td>
                      </tr>
                    )}

                    {/* Delivery Charges */}
                    {invoiceData?.deliveryCharges > 0 && (
                      <tr>
                        <td>Delivery Charges</td>
                        <td></td>
                        <td></td>
                        {/* <td></td> */}
                        <td>{invoiceData?.currency} {invoiceData?.deliveryCharges}</td>
                      </tr>
                    )}
                    <tr style={{}}>
                      <td></td>
                      <td></td>
                      <td style={{ fontSize: "16px", fontWeight: "bold", color: "#333", lineHeight: "1.2", margin: "0" }}>Subtotal: </td>
                      <td style={{ fontSize: "16px", fontWeight: "bold", color: "#333" }}>{invoiceData?.currency} {invoiceData?.subtotal?.toFixed(2)}</td>

                    </tr>
                    <tr style={{}}>
                      <td style={{ fontSize: "15px", fontWeight: "bold", color: "#333" }}>Discounts:</td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    {invoiceData?.monthlyFee > 0 && invoiceData?.monthlyDiscountPercent > 0 && (
                      <tr>
                        <td>Monthly Fee discount</td>
                        <td></td>
                        <td>{invoiceData?.monthlyDiscountPercent}%</td>
                        {/* <td></td> */}
                        <td>{invoiceData?.currency} {invoiceData?.monthlyDiscount}</td>
                      </tr>
                    )}

                    {invoiceData?.abacusFee > 0 && invoiceData?.abacusDiscountPercent > 0 && (
                      <tr>
                        <td>Abacus Fee discount</td>
                        <td></td>
                        <td>{invoiceData?.abacusDiscountPercent}%</td>
                        {/* <td></td> */}
                        <td>{invoiceData?.currency} {invoiceData?.abacusDiscount}</td>
                      </tr>
                    )}

                    {invoiceData?.membershipFee > 0 && invoiceData?.membershipDiscountPercent > 0 && (
                      <tr>
                        <td>Membership Fee discount</td>
                        <td></td>
                        <td>{invoiceData?.membershipDiscountPercent}%</td>
                        {/* <td></td> */}
                        <td>{invoiceData?.currency} {invoiceData?.membershipDiscount}</td>
                      </tr>
                    )}
                    <tr style={{ fontWeight: "bold", fontSize: "16px", lineHeight: "1.2", margin: "0" }}>
                      <td></td>
                      <td></td>
                      <td>Total Discount:</td>
                      <td>{invoiceData?.currency} {(invoiceData?.subtotal - invoiceData?.total).toFixed(2)}</td>
                    </tr>
                    <tr style={{ fontWeight: "bold", fontSize: "14px", lineHeight: "0.8", margin: "0" }}>
                      <td></td>
                      <td></td>
                      <td>Transaction Charges:</td>
                      <td>{invoiceData?.currency} {invoiceData?.totalPayable * (invoiceData?.transactionCharges / 100)} ({invoiceData?.transactionCharges}%)</td>
                    </tr>
                    <tr className="total">
                      <td></td>
                      <td></td>
                      <td>Total Payable:</td>
                      <td>{invoiceData?.currency} {invoiceData?.totalPayable?.toFixed(2)}</td>
                    </tr>
                  </tbody>
                </table>

                {/* <p> <strong>Discounts:</strong> </p> */}
                {/* <p className='grayedColor'>{invoiceData?.monthlyFee > 0 && `Monthly Fee discount@${invoiceData?.monthlyDiscountPercent}% : ${invoiceData?.currency} ${invoiceData?.monthlyDiscount}`}</p> */}
                {/* <p className='grayedColor'>{invoiceData?.abacusFee > 0 && `Abacus Fee discount@${invoiceData?.abacusDiscountPercent}% : ${invoiceData?.currency} ${invoiceData?.abacusDiscount}`}</p> */}
                {/* <p className='grayedColor'>{invoiceData?.membershipFee > 0 && `Membership Fee discount@${invoiceData?.membershipDiscountPercent}% : ${invoiceData?.currency} ${invoiceData?.membershipDiscount}`}</p> */}

                {/* Subtotal */}
                {/* <p className="subtotal">Subtotal: {invoiceData?.currency} {invoiceData?.subtotal}</p> */}
                {/* <p className="total">Total Payable: {invoiceData?.currency} {invoiceData?.totalPayable}</p> */}

                {/* Payment Method */}
                {invoiceData?.note && (
                  <div className="note-section" style={{ marginBottom: "20px" }}>
                    <p><strong>Note:</strong> {invoiceData?.note}</p>
                  </div>
                )}
                <p className="payment-details-heading"><strong>Payment Details:</strong></p>
                <div className="payment-details-content" style={{ display: "flex", justifyContent: "center" }}>
                  <div style={{ width: "100%" }}>
                    {formData.bankDetails.split('\n').map((line, lineIndex) => (
                      <div key={lineIndex} className="mb-2">
                        {line.split('; ').map((segment, segmentIndex) => {
                          const [label, value] = segment.split(': ');
                          return (
                            <p key={segmentIndex} className="text-gray-600" style={{ margin: "2px 0" }}>
                              <strong>{label}:</strong> <span>{value}</span>
                            </p>
                          );
                        })}
                      </div>
                    ))}
                  </div>
                </div>

                {/* <br></br>
                <br></br> */}
              </div>

              {/* Total Payable */}
              <img src={footer} height={400} style={{
                position: "absolute",
                bottom: 0,
                left: 0,
                width: "100%",
                zIndex: 0
              }}></img>
              {/* <button onClick={downloadPDF}>Download PDF</button> */}
            </div>
          </div>
        )}
      </div>



      <div className="invoice-list-section">
        {/* Unified Header Section */}
        <div className="invoice-list-top-header" style={{ marginBottom: "20px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h2>Student Invoices</h2>
          <div className="invoice-search-wrapper" style={{ display: "flex", gap: "10px" }}>
            <input
              type="text"
              placeholder="Search by student name..."
              className="invoice-global-search"
              style={{ padding: "10px", borderRadius: "5px", border: "1px solid #ddd", width: "300px" }}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <select name="student" className='invoice-search-select' value={selectedStudentForTable} onChange={handleTableStudentChange} style={{ padding: "10px", borderRadius: "5px", border: "1px solid #ddd", width: "200px", marginTop: 0 }}>
              <option value="">Filter by Student</option>
              {students.map(student => (
                <option key={student.User_id} value={parseInt(student.User_id)}>{student.firstname} {student?.lastname}</option>
              ))}
            </select>
          </div>
        </div>

        {!showInvoices ? (
          <div className="invoice-load-container">
            <div className="invoice-load-card">
              <h3>Load Invoice History</h3>
              <p>View all past student invoices and payments</p>
              <button
                className="load-invoices-btn"
                onClick={() => {
                  setShowInvoices(true);
                  // fetchInvoiceList(); // Triggered by useEffect now
                }}
              >
                Load All Invoices
              </button>
            </div>
          </div>
        ) : (
          <div className="invoice-list-content">
            <div className="invoice-list-header">
              <h3>Invoice History</h3>
              <button
                className="close-invoices-btn"
                onClick={() => {
                  setShowInvoices(false);
                  setFilteredInvoices([]);
                  setPage(1);
                }}
              >
                Close Invoices
              </button>
            </div>
            <div className="invoice-list-display">
              <table style={{ width: "100%", alignItems: 'center', borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th>Paid</th>
                    <th>Invoice No.</th>
                    <th>
                      Student Name
                    </th>
                    <th>Course</th>
                    <th>Invoice Date</th>
                    <th>Amount Due</th>
                    <th>Due Date</th>
                    <th>Amount Paid</th>
                    <th>Paid on mm/dd/yyyy</th>
                    <th>Receipt</th>
                  </tr>
                </thead>
                <tbody>
                  {renderInvoiceList}
                  <tr ref={loadingRef}>
                    <td colSpan="10" style={{ textAlign: 'center', padding: '1rem' }}>
                      {isLoading && <div>Loading more invoices...</div>}
                      {!hasMore && <div>No more invoices to load</div>}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
      {/* Footer */}
      <Footer />
    </>
  );
};

// Add PropTypes for better type checking
InvoicePage.propTypes = {
  // Add your prop types here
};

export default memo(InvoicePage);
